import { Box, DialogActions, DialogContent, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import ActionButton from "../../components/Button/ActionButton";
import DialogComponent from "../../components/Dialog/Dialog";
import { PaymentLine } from "../../hooks/useRequestPayment";
import { semanticColors } from "../../utils/colors";
import { typography } from "../../utils/typography";

const messageSx = {
  ...typography.body.l,
  color: semanticColors.text.primary
};

/**
 * Asks before dropping a line. `line` doubles as the open state: there is
 * nothing to confirm without one, and its description names what is going.
 */
export default function RemoveLineDialog({
  line,
  onCancel,
  onConfirm
}: {
  line: PaymentLine | null;
  onCancel: () => void;
  onConfirm: (line: PaymentLine) => void;
}) {
  const { t } = useTranslation();

  return (
    <DialogComponent
      open={Boolean(line)}
      handleModal={onCancel}
      headerTxt={t("requestPayment.removeLineConfirmTitle")}
    >
      <DialogContent>
        <Typography sx={messageSx}>
          {t("requestPayment.removeLineConfirmMessage", {
            description: line?.description ?? ""
          })}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Box display="flex" gap={1} p={1}>
          <ActionButton
            label={t("common.no")}
            onClick={onCancel}
            variant="secondary"
          />
          <ActionButton
            label={t("common.yes")}
            onClick={() => line && onConfirm(line)}
            variant="danger"
          />
        </Box>
      </DialogActions>
    </DialogComponent>
  );
}
